import { BRAND_NAME } from '@/lib/brand';
import { cn } from '@/lib/utils';

interface BrandMarkProps {
  compact?: boolean;
  className?: string;
  textClassName?: string;
}

/**
 * Geometric identity mark: two brackets enclosing a single accent node —
 * "access, bounded." Drawn from currentColor + the brand accent, so it
 * inverts cleanly between the matte-black and Twitter-light themes. No
 * gradient, no icon-in-a-rounded-box.
 */
export function BrandGlyph({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 28 28"
      fill="none"
      aria-hidden="true"
      className={cn('h-7 w-7', className)}
    >
      {/* left bracket */}
      <path
        d="M10 4H7a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h3"
        stroke="currentColor"
        strokeWidth="2.4"
        strokeLinecap="round"
      />
      {/* right bracket */}
      <path
        d="M18 4h3a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3h-3"
        stroke="currentColor"
        strokeWidth="2.4"
        strokeLinecap="round"
      />
      {/* accent node */}
      <circle cx="14" cy="14" r="3" fill="hsl(var(--primary))" />
    </svg>
  );
}

export function BrandMark({ compact = false, className, textClassName }: BrandMarkProps) {
  return (
    <div className={cn('flex items-center gap-2.5', className)}>
      <BrandGlyph className={cn('text-foreground', compact ? 'h-6 w-6' : 'h-7 w-7')} />
      {!compact && (
        <span
          className={cn(
            'font-mono text-[15.5px] font-semibold tracking-[-0.02em] text-foreground',
            textClassName
          )}
        >
          {BRAND_NAME.replace('.me', '')}
          <span className="text-muted-foreground">.me</span>
        </span>
      )}
    </div>
  );
}
